import React, { createRef } from 'react';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import PhotoLibraryIcon from '@material-ui/icons/PhotoLibrary';
import Loading from 'shared/components/Loading';
import modalStyles from 'shared/components/modalStyles';
import ImageGalleryContainer from 'app/components/ImageGalleryContainer';
import AccessCodeMomentLookup from 'app/components/AccessCodeMomentLookup';
import messages, { FormattedMessage, withValues } from 'shared/messages/messages';
import Viewport from 'app/components/Viewport';
import config from 'shared/config/config';
import { format, isThisSecond } from 'date-fns';


import {
    downloadMomentBlob
} from 'shared/services/DownloadService'

import {
    reKnockOutMoment,
    removeMoment,
    selectMoments,
    unselectMoments,
    getSelectedPrintSizes
} from 'shared/actions/cartActions';

import {
    viewReceipt,
    setScrollPosition,
    unselectMoment as unselectKioskMoment,
    getMomentsV2,
    clearPrePrints
} from 'app/actions/kioskActions';

import {
    setPhotoSwipeMoment,
    showAuthorizeKnockout
} from 'app/actions/photoSwipeActions';

import {
    trackEvent
} from 'shared/services/Analytics';

import {
    GALLERY_SCREEN,
    CART_SCREEN,
    PRE_PRINTING_SCREEN,
} from 'app/utils/Constants';

import {
    MULTI_PRINT_MODE
} from 'shared/utils/Constants'

import {
    getCartMoments,
    getSelectedCount,
    getSelectedMoments,
    getAvailableMomentIds
} from 'shared/selectors/cartSelectors';

import {
    getSelectedPrintMoments,
    getPortalMoments
} from 'app/selectors/kioskSelectors';

import {
    LEGACY_THEME,
    CLUBMED_THEME,
} from 'shared/config/themes';

import {
    getStore
} from 'shared/services/Store';

const styles = () => ({
    viewport: {
        position: 'relative',
        float: 'left',
        width: '100%',
        marginTop: '3.75rem',
        minHeight: '100vh'
    },
    momentsPanel: {
        position: 'relative',
        float: 'left',
        width: '72vw',
        minHeight: '100vh',
        marginTop: '4rem',
        background: '#707072'
    },
    panelHeader: {
        float: 'left',
        width: '100%',
        fontSize: '1.2rem',
        fontWeight: 700,
        textAlign: 'left',
        margin: config.cart_panel_header_margin,
        color: config.cart_panel_header_font_color,
        fontFamily: config.main_font
    },
    toolbar: {
        position: 'fixed',
        display: 'flex',
        justifyContent: 'space-between',
        zIndex: 6,
        top: config.cart_toolbar_top,
        left: 0,
        right: 0,
        height: '4.8rem',
        background: config.cart_toolbar_bg_color,
        boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
        padding: '0.5rem 1rem'
    },
    toolbarLeftColumn: {
        flex: 1,
        minWidth: 0
    },
    tapMessage: {
        float: 'left',
        textAlign: 'left',
        fontSize: '0.8rem',
        fontFamily: config.sub_font
    },
    actions: {
        float: 'right',
        marginTop: '0.5rem',
    },
    completePurchaseButton: {
        float: 'right',
        textAlign: 'center',
        padding: '0.5rem 1.3rem',
        fontWeight: 600,
        background: 'linear-gradient(#4ea4c3, #007aa1)',
        borderRadius: '3px',
        border: 'none',
        color: '#fff',
        fontSize: '16px',
        fontFamily: config.root_font_family,
        margin: '5px'
    },
    completePurchaseButton2: {
        float: 'right',
        textAlign: 'center',
        padding: '0.5rem 1.3rem',
        fontWeight: 600,
        background: '#3A8DDE',
        borderRadius: '3px',
        border: 'none',
        color: '#fff',
        marginTop: '0.4rem',
        margin: '5px'
    },
    printSizeButton: {
        float: 'right',
        textAlign: 'center',
        marginRight: '2rem',
        padding: '0.8rem 1.3rem',
        fontWeight: 600,
        background: 'linear-gradient(#ffffff, #f1f1f1)',
        borderRadius: '3px',
        border: '1px solid #dcdcdc',
        boxShadow: '0 0 2px #dcdcdc',
        color: '#2b8eb0'
    },
    cartCount: {
        float: 'right',
        fontSize: '1.3rem',
        fontWeight: 600,
        marginTop: '-0.2rem',
        marginRight: '0.5rem',
        padding: '0.5rem 0',
        textTransform: 'uppercase',
        color: config.kiosk_cart_count_font_color,
        fontFamily: config.sub_font
    },
    cartCount2: {
        float: 'right',
        fontSize: '1rem',
        marginTop: '0',
        marginRight: '0.5rem',
        padding: '1em 0',
        color: '#3A8DDE',
        fontFamily: config.sub_font,
        fontWeight: 600
    },
    cartIcon: {
        fontSize: '1.8rem',
        marginTop: '-0.2rem',
        marginLeft: '0.4rem',
        marginRight: config.kiosk_cart_icon_margin_right
    },
    loadScreen: {
        top: '20em'
    },
    ...modalStyles()
});

class PrePrintGallery extends React.Component {
    constructor(props) {
        super(props);

        const { screen } = props;

        this.store = getStore();
        this.main = createRef();
        this.handleRefresh = this.handleRefresh.bind(this);

        this.state = {
            loading: false,
            showPrintSizeSelection: false,
            showAccessCodeLookup: false,
            screen: screen || GALLERY_SCREEN,
            processingKnockout: false,
            displayAccessCodes: false,
            galleryKey: Math.random(),
            hasMore: true,
            page: 1,
            scrollPosition: 0,
            data: []
        }
    }

    componentDidMount() {
        const {
            settings,
            user
        } = this.props;

        if (user) {
            this.loadItems(true).then(() => {
                this.loadItems(false);
            })
            trackEvent('Kiosk.LoadGallery', {
                userId: user.id,
                storyId: user.story_id,
                moments: this.props.moments.allIds
            });
            window.addEventListener("scroll", this.handleScroll);
        }
    }

    componentWillUnmount() {
        window.removeEventListener("scroll", this.handleScroll);
    }

    handleScroll = async () => {
        const { loading, hasMore } = this.state;

        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        const windowHeight = window.innerHeight;
        const documentHeight = document.documentElement.scrollHeight;
        if (scrollTop > 0) {
            this.props.setScrollPosition(scrollTop);
        }


        if (loading || !hasMore) return;

        // Trigger when near bottom
        if (scrollTop + windowHeight >= documentHeight - 1) {
            this.loadItems();
        }
    };


    loadItems = async (countOnly = false) => {
        const { page, items } = this.state;

        const { getMomentsV2, settings, user } = this.props;

        let today = new Date();
        let yesterday = new Date(today.setDate(today.getDate() - 1));
        let dateFilter = yesterday.toISOString().split('T')[0]

        let jobIds = settings.pre_print_job_ids;
        if (!jobIds.includes(settings.job_id)) {
            jobIds.push(settings.job_id);
        }

        // TODO: If query performance is poor, it may be worth looking into add "IN"
        // as a portal filter option since current "OR"s could be a problem
        let jobIdParams = jobIds.map((job_id) => {
            return { filterClass: 'number', filterType: 'equals', value: job_id.toString(), operator: 'OR' }
        });

        let perPage = 50;
        let sortModel = [{ sort: "desc", colId: "id" }];
        let filterModel = {
            preview: [{
                filterClass: 'date',
                filterType: 'greaterThan',
                value: dateFilter,
                operator: 'AND'
            }],
            job_id: jobIdParams,
            hidden: [{
                filterClass: 'number',
                filterType: 'notEqual',
                value: '1',
                operator: 'AND'
            }],
            _operator: [{
                operator: 'AND',
                value: 'AND',
                filterClass: "",
                'filterType': ""
            }],
        }

        this.setState({ loading: true });



        var data = await getMomentsV2(this.state.refresh ? 1 : page, perPage, filterModel, sortModel, this.props.moments, countOnly);
        const windowHeight = window.innerHeight;
        setTimeout(() => {
            if (this.main.current) {
                if (!countOnly) {
                    if (this.state.page > 2) {
                        window.scrollTo(0, document.documentElement.scrollHeight - windowHeight - 50);
                    } else {
                        window.scrollTo(0, 0);
                    }
                    // if (data.length > 0) {
                    //     window.scrollTo(0, document.documentElement.scrollHeight - windowHeight - 50);
                    // }
                }
            }
        }, 600);

        this.setState({
            page: countOnly ? page : page + 1,
            loading: false,
            hasMore: data.length > this.state.data.length,
            data: data
        });
    };

    async downloadPrints() {
        const { settings, prints } = this.props;

        let includeAccessCode = this.state.displayAccessCodes;
        for (let print of prints) {
            downloadMomentBlob(print, includeAccessCode);
        }
    }

    loadSelectedPrintSizes() {
        const { user, getSelectedPrintSizes } = this.props;
        return getSelectedPrintSizes(user.story_id);
    }

    closePrintSizeSelection() {
        window.currentModal && window.currentModal.close();
        setTimeout(() => {
            this.setState({ showPrintSizeSelection: false });
            document.body.style.overflowY = 'auto';
        }, 500);
    }

    showPrintSizeSelection() {
        this.setState({ showPrintSizeSelection: true });
    }

    isLegacyTheme() {
        const { settings: { theme } } = this.props;
        return theme === LEGACY_THEME || theme === CLUBMED_THEME;
    }

    getNextButtonClass() {
        const { classes } = this.props;

        if (this.isLegacyTheme()) {
            return classes.completePurchaseButton;
        } else {
            return classes.completePurchaseButton2;
        }
    }

    getNextButtonLabel() {
        const { settings } = this.props;
        const { screen } = this.state;

        let label = messages.button_print;

        return <FormattedMessage {...label} />
    }

    getNextButtonAction() {
        const { clearPrePrints } = this.props;

        return async () => {
            await this.downloadPrints();
            clearPrePrints();
        };
    }

    getNextButton() {
        const { user, selectedPrintMomentIds } = this.props;
        let btnClass = this.getNextButtonClass();

        // if unlock all has been activated, then allow user to buy more prints.
        // if no prints are selected then just show the View Receipt button
        let showViewReceipt = user.unlocked && selectedPrintMomentIds.length === 0;

        let btnLabel, btnAction;
        if (showViewReceipt) {
            btnLabel = <FormattedMessage {...messages.button_view_receipt} />;
            btnAction = () => this.props.viewReceipt();
        } else {
            btnLabel = this.getNextButtonLabel();
            btnAction = this.getNextButtonAction();
        }

        return (
            <span>
                <button className={btnClass} onClick={btnAction}>
                    {btnLabel}
                </button>
            </span>
        );
    }

    getPrintSizesButton() {
        const { classes, user, selectedPrintMomentIds, selectedPrintSizes } = this.props;
        let totalPrints = 0;
        let btnLabel, btnAction;
        // if unlock all has been activated, then allow user to buy more prints.
        // if no prints are selected then just show the View Receipt button
        let showViewReceipt = user.unlocked && selectedPrintMomentIds.length === 0;

        for (let printSize of selectedPrintSizes) {
            totalPrints += printSize.print_count;
        }

        btnLabel = 'Selected Print Sizes (' + totalPrints + ')';
        btnAction = () => this.showPrintSizeSelection();

        // let sizes = [];
        // for (var printSize of selectedPrintSizes) {
        //   let sizeIndex = sizes.findIndex(x => x.id == printSize.id);
        //   btnLabel = '';

        //   if (sizeIndex < 0) {
        //     sizes.push(printSize);
        //   } else {
        //     continue;
        //   }
        // }

        // for (var printSize of sizes) {

        //   btnLabel += btnLabel ? ", " + printSize.sizeDesc : printSize.sizeDesc;
        // }

        return (
            <button className={classes.printSizeButton} onClick={btnAction}>
                {btnLabel}
            </button>
        );
    }

    getGalleryIcon() {
        const { classes, settings, moments, portalMomentCount } = this.props;

        // currently the gallery icon is only being shown for legacy themes.
        // it might be good to implement it for newer themes when both
        // the gallery and cart screens are being used, so that the user
        // can see the number of total images in addition to the those selected
        if (!this.isLegacyTheme() || !settings.gallery_screen) {
            return null;
        }

        let imageCount = portalMomentCount;

        return (
            <p className={classes.cartCount}>
                <span>{imageCount}</span>
                <PhotoLibraryIcon className={classes.cartIcon} />
            </p>
        );
    }

    getHeader() {
        const { classes, settings, user } = this.props;
        const { screen } = this.state;

        let msg = messages.kiosk_gallery_header_pre_print;

        return (
            <p className={classes.panelHeader} style={{ margin: '0 0 0.5rem 0' }}>
                <FormattedMessage {...msg} />
            </p>
        );
    }

    getInstructions() {
        const { classes, settings, user } = this.props;
        const { screen } = this.state;

        let msg = messages.kiosk_gallery_instructions_pre_print;

        return (
            <p className={classes.tapMessage}>
                <FormattedMessage {...msg} />
            </p>
        );
    }

    getImageGalleryHeader() {
        const { settings } = this.props;
        const { screen } = this.state;

        let msg;
        switch (screen) {
            case GALLERY_SCREEN:
                if (settings.theme === CLUBMED_THEME) {
                    msg = messages.kiosk_images_header_clubmed;
                } else {
                    msg = messages.kiosk_images_header;
                }
                break;

            case CART_SCREEN:
                msg = messages.kiosk_images_header_selected;
        }

        return <FormattedMessage {...msg} />
    }

    getImageGallery() {
        const { classes, selectedMomentIds, moments } = this.props;
        const { screen, displayAccessCodes } = this.state;

        let header = this.getImageGalleryHeader();
        let width = '100vw';

        let viewImageOnTap, cart;
        viewImageOnTap = true; // unselecting causes the image to vanish
        cart = true;

        let fontColor = null;
        // disabling for legacy themes for now, this can be folded into config
        if (!this.isLegacyTheme()) {
            fontColor = config.kiosk_toolbar_header_font_color;
        }

        return (
            <div className={classes.momentsPanel} style={{ width }}>
                <Viewport>
                    <ImageGalleryContainer
                        header={header}
                        columns={3}
                        width={width}
                        moments={moments}
                        selectedMomentIds={selectedMomentIds}
                        resolution={0}
                        selectEnabled={false}
                        showSelectAll={false}
                        allSelected={false}
                        printsEnabled={true}
                        removeEnabled={false}
                        showRemoveModal={false}
                        viewImageOnTap={viewImageOnTap}
                        cart={cart}
                        showDates={true}
                        showCountByDate={false}
                        fontColor={fontColor}
                        selectCartItem={false}
                        displayAccessCodes={displayAccessCodes}
                        galleryWorker={this.props.galleryWorker}
                        galleryKey={this.state.galleryKey}
                    />
                </Viewport>
                <div id="bottom"></div>
            </div>
        );
    }

    getAccessCodeLookupDialog = () => {
        return <AccessCodeMomentLookup visible={this.state.showAccessCodeLookupDialog} onClose={(fullMode) => {
            this.showAccessCodeLookupDialog(false);
            if (fullMode) {
                this.loadItems();
            }
            this.setState({ page: 1, galleryKey: Math.random() });
        }} />
    }

    showAccessCodeLookupDialog = (visible) => {
        this.setState({ showAccessCodeLookupDialog: visible });
    }

    reknockOutAction() {
        const { reKnockOutMoment, reKnockOutMomentId, settings, user, getMoments } = this.props;
        this.setState({ processingKnockout: true });
        reKnockOutMoment(reKnockOutMomentId, settings.token).then(() => {
            this.setState({ processingKnockout: false });
            getMoments(settings.token, user.story_id);
        }).catch((ex) => {
            this.setState({ processingKnockout: false });
        })
    }

    async toggleAccessCodes() {
        this.setState({ displayAccessCodes: !this.state.displayAccessCodes });
    }

    handleRefresh() {
        this.setState({ page: 1 }, () => {
            this.loadItems();
            this.setState({ galleryKey: Math.random() });
        });
    }

    render() {
        // this will render either the gallery or cart screen,
        // which are mostly the same structure.
        // individual components change based on the screen and kiosk settings
        const { classes, user, getMoments } = this.props;

        if (this.state.loading) {
            return (<Loading />);
        }

        if (!user) {
            return null;
        }

        let header = this.getHeader();
        let instructions = this.getInstructions();
        let nextButton = this.getNextButton();
        let galleryIcon = this.getGalleryIcon();
        let imageGallery = this.getImageGallery();
        let btnClass = this.getNextButtonClass();
        let accessCodeLookupDialog = this.getAccessCodeLookupDialog();

        return (
            <div ref={this.main} id='mainContainer' className={classes.viewport}>
                <div className={classes.toolbar}>
                    <div className={classes.toolbarLeftColumn}>
                        {header}
                        {instructions}
                    </div>
                    <div className={classes.actions}>
                        <div style={{ float: 'right', cursor: 'pointer' }}>
                            <button className={btnClass} onClick={() => this.showAccessCodeLookupDialog(true)}>
                                Access Code Search
                            </button>
                            <button className={btnClass} onClick={() => this.toggleAccessCodes()}>
                                <FormattedMessage {...messages.button_toggle_access_codes} />
                            </button>
                            <button className={btnClass} onClick={this.handleRefresh}>
                                <FormattedMessage {...messages.button_refresh} />
                            </button>
                            {nextButton}
                            {galleryIcon}
                        </div>
                    </div>
                </div>
                {imageGallery}
                {accessCodeLookupDialog}
                <div id="bottom" style={{ position: 'fixed', bottom: 0, left: 0 }}></div>
            </div>
        )
    }
}

const mapStateToProps = state => ({
    settings: state.kioskReducer.settings,
    user: state.kioskReducer.user,
    moments: getPortalMoments(state),
    selectedMoments: getSelectedMoments(state),
    selectedMomentIds: state.cartReducer.selectedMomentIds,
    selectedPrintMomentIds: state.cartReducer.selectedPrintMomentIds,
    selectedCount: getSelectedCount(state),
    scrollPosition: state.kioskReducer.scrollPosition,
    availableMomentIds: getAvailableMomentIds(state),
    selectedPrintSizes: state.cartReducer.selectedPrintSizes,
    authorizeKnockOutVisible: state.photoSwipeReducer.authorizeKnockOutVisible,
    reKnockOutMomentId: state.photoSwipeReducer.reKnockOutMomentId,
    selectedPrintSizes: state.cartReducer.selectedPrintSizes,
    authorizeKnockOutVisible: state.photoSwipeReducer.authorizeKnockOutVisible,
    reKnockOutMomentId: state.photoSwipeReducer.reKnockOutMomentId,
    prints: getSelectedPrintMoments(state),
    portalMomentCount: state.kioskReducer.portalMomentCount
});

export default connect(mapStateToProps, { clearPrePrints, getMomentsV2, reKnockOutMoment, showAuthorizeKnockout, viewReceipt, setPhotoSwipeMoment, removeMoment, selectMoments, unselectMoments, setScrollPosition, unselectKioskMoment, getSelectedPrintSizes })(withStyles(styles)(PrePrintGallery));